import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";

export const deleteSpecialItem = (token, id: string): AxiosReturn<{}> => {
  return axios.delete(Requests.specialItemsByID(id), {
    headers: {
      token,
    },
  });
};
